import { VarClassEnum, WorkshopCheckInLookupModel, WorkshopCheckInVehicleShortModel } from 'api/generated';
import { WorkshopCheckInService } from 'api/generated/services/WorkshopCheckInService';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useVhcQueryKey = 'VhcQueryKey';

export type GetLookupVhcInput = {
  wip?: number;
  regNo?: string;
  branchId?: number;
  activeOnly?: boolean;
};

type LookupVhcModel = WorkshopCheckInLookupModel & {
  vehicle?: WorkshopCheckInVehicleShortModel & { varClass: VarClassEnum; model: string; description: string };
};

const fetchLookupVhc = async (input: GetLookupVhcInput) => {
  const data = await WorkshopCheckInService.getWorkshopCheckInWipLookup(
    input.wip,
    input.regNo,
    input.branchId,
    input.activeOnly
  );
  return data as LookupVhcModel;
};

export const useLookupVhcQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input: GetLookupVhcInput,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchLookupVhc>>,
      QueryError,
      Awaited<ReturnType<typeof fetchLookupVhc>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([useVhcQueryKey, ...(queryKey ?? [{ ...input }])], () => fetchLookupVhc(input), options);
